/**
 * Exports data to a CSV file.
 * 
 * @param {string[]} headers - Array of column headers (e.g. ["Name", "Price"])
 * @param {Array<Array<any>>} rows - Array of rows, where each row is an array of values corresponding to headers.
 * @param {string} filename - Name of the file to download (default: "export.csv")
 */
export const exportToCSV = (headers, rows, filename = 'export.csv') => {
    if (!headers || !rows || rows.length === 0) {
        console.warn("ExportToCSV: No headers or data provided.");
        return;
    }

    const csvContent = [
        headers.join(","),
        ...rows.map(row =>
            row.map(cell => {
                if (cell === null || cell === undefined) return "";
                const cellStr = String(cell);
                // Escape quotes and wrap in quotes if it contains comma, quote or newline
                if (cellStr.includes('"') || cellStr.includes(',') || cellStr.includes('\n')) {
                    return `"${cellStr.replace(/"/g, '""')}"`;
                }
                return cellStr;
            }).join(",")
        )
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    link.style.visibility = 'hidden';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};